module.exports = __webpack_public_path__ + "img/ofr.3dd9a076.png";